import { isUsTemaRegion } from "../../config/temaRegion";

/** U.S. classroom phrase when the market is US; otherwise the existing phrase. */
export function usClassroomCopy(usPhrase, currentPhrase) {
  return isUsTemaRegion() ? usPhrase : currentPhrase;
}

export function getCreateQuestionsNavLabel() {
  return usClassroomCopy("Worksheets and Exit Tickets", "Create Questions & Sheets");
}

export function getCreateQuestionsBreadcrumbLabel() {
  return usClassroomCopy("Worksheets and Exit Tickets", "Create Questions");
}

/** Score badge such as "1 Point" / "2 Points", or "1 Mark" / "2 Marks" in India. */
export function formatScoreLabel(count) {
  const value = Number(count);
  const amount = Number.isFinite(value) && value > 0 ? value : 1;
  if (isUsTemaRegion()) {
    return amount === 1 ? "1 Point" : `${amount} Points`;
  }
  return amount === 1 ? "1 Mark" : `${amount} Marks`;
}

/** Inline count for exported bullets. India stays "N marks". */
export function formatScoreCountInline(count) {
  const value = Number(count);
  const amount = Number.isFinite(value) && value > 0 ? value : 0;
  if (isUsTemaRegion()) {
    return `${amount} ${amount === 1 ? "point" : "points"}`;
  }
  return `${amount} marks`;
}

export function maximumScoreLabel() {
  return usClassroomCopy("Maximum Points", "Maximum Marks");
}

export function totalScoreLabel() {
  return usClassroomCopy("Total Points", "Total Marks");
}

export function scorePerQuestionLabel() {
  return usClassroomCopy("Points/Q", "Marks/Q");
}

export function scoreSingularFieldLabel() {
  return usClassroomCopy("Point", "Mark");
}

export function examDocumentFallbackTitle() {
  return usClassroomCopy("Assessment", "Question Paper");
}

export function recentExamDocumentsLabel() {
  return usClassroomCopy("Recent Assessments", "Recent Question Papers");
}

export function questionPaperDocumentTypeLabel() {
  return usClassroomCopy("Assessment", "Question Paper");
}

export function couldNotGenerateExamMessage() {
  return usClassroomCopy(
    "Could not generate assessment. Please try again.",
    "Could not generate question paper. Please try again.",
  );
}

export function totalScoreEmptyMessage() {
  return usClassroomCopy(
    "Total points cannot be empty.",
    "Total marks cannot be empty.",
  );
}

export function totalScoreMinimumMessage() {
  return usClassroomCopy(
    "Total points cannot be less than 10.",
    "Total marks cannot be less than 10.",
  );
}

export function totalScoreMaximumMessage(max) {
  return usClassroomCopy(
    `Total points must be at most ${max}.`,
    `Total marks must be at most ${max}.`,
  );
}

export function totalScoreAtLeastMessage(limit) {
  return usClassroomCopy(
    `Total points must be at least ${limit}.`,
    `Total marks must be at least ${limit}.`,
  );
}

export function totalScoreAtMostMessage(limit) {
  return usClassroomCopy(
    `Total points must be at most ${limit}.`,
    `Total marks must be at most ${limit}.`,
  );
}

export function totalScoreFieldName() {
  return usClassroomCopy("Total points", "Total marks");
}
